import { useNavigate } from "react-router";
import { CREATE_CONSIGNMENT, ORDER_DETAILS } from "../../../constants/routes";
import { CreateShipmentProvider } from "../../../hooks/useCreateShipmentContext";
import { useParamAsNumber } from "../../../hooks/useParamAsNumber";
import { NavigationBar } from "../../navigation/NavigationBar";
import { OrderCreateConsignmentType } from "./OrderCreateConsignmentType";

export const OrderCreateConsignment = () => {
  const navigate = useNavigate();
  const orderId = useParamAsNumber(CREATE_CONSIGNMENT, "orderId");
  return (
    <CreateShipmentProvider>
      <NavigationBar
        title={"Create Shipment"}
        leftIcon={"CLOSE"}
        onClickLeftIcon={() =>
          navigate(`${ORDER_DETAILS.href({ orderId })}?tab=All+orders`)
        }
      />
      <OrderCreateConsignmentType />
    </CreateShipmentProvider>
  );
};
